import { render, staticRenderFns } from "./update-skill.vue?vue&type=template&id=d8970b04&"
import script from "./update-skill.vue?vue&type=script&lang=js&"
export * from "./update-skill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports